/* eslint-disable no-underscore-dangle */
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { filter, get, isEmpty, map, orderBy, slice } from 'lodash-es';
import propTypes from 'prop-types';
import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import ClipText from '../../components/ClipText';
import GuestRating from '../../components/GuestRating';
import LoadingScreen from '../../components/LoadingIndicator';

dayjs.extend(relativeTime);
const Review = props => {
  const { review } = props;
  return (
    <div className="c-reviews__item flex flex-direction-col pt10 pb10 guest-review-wrap reviews_wrap">
      <div className="c-reviews__item-desc flex flex-direction-row p0 w100p">
        <div className="flex flex-direction-col">
          {!isEmpty(review.user) &&
            !props.myTherapistFlow && (
              <div className="c-reviews__customer">
                {review.user.first_name || 'name_not_found'}
              </div>
            )}
          <GuestRating rating={Number(review.rating) || 0} />
        </div>
        <div className="c-reviews__months">
          {dayjs(review.created_at).fromNow()}
        </div>
      </div>
      <div className="c-reviews__comment w100p">
        {review.comment && <ClipText text={review.comment} clipLength={200} />}
      </div>
    </div>
  );
};

Review.propTypes = {
  review: propTypes.object,
  myTherapistFlow: propTypes.bool,
};

class TherapistReviews extends Component {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.getDefaultState = this.getDefaultState.bind(this);
    this.paginateReviews = this.paginateReviews.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
  }

  getDefaultState() {
    const { paginate } = this.props;
    if (paginate) {
      return {
        offset: 0,
        reviewsAtOnce: 3,
      };
    }
    return { offset: 0, reviewsAtOnce: 3, showMoreClicked: false };
  }

  paginateReviews(data) {
    const { reviewsAtOnce } = this.state;
    const _offset = Math.ceil(data.selected * reviewsAtOnce);
    const therapistId = get(this.props, 'therapist.id');
    this.props.fetchReviews(
      therapistId,
      _offset,
      reviewsAtOnce,
      this.props.myTherapistFlow,
    );
    this.setState({
      offset: _offset,
    });
  }

  handleShowMore() {
    const { showMoreClicked } = this.state;
    this.setState({ showMoreClicked: !showMoreClicked });
  }

  render() {
    const {
      paginate,
      titleText,
      allReviews,
      therapistReviews,
      count,
      sliceReviews,
      fetchingTherapistReviews,
    } = this.props;
    const { reviewsAtOnce, offset, showMoreClicked } = this.state;
    let reviews = [];
    reviews = therapistReviews || allReviews;
    reviews = filter(reviews, r => r && (r.comment || r.rating));
    reviews = orderBy(reviews, 'created_at', ['desc']);
    // eslint-disable-next-line no-nested-ternary
    const sliceCondition = showMoreClicked
      ? reviews.length + 1
      : reviewsAtOnce + offset;
    reviews = sliceReviews ? slice(reviews, offset, sliceCondition) : reviews;
    return (
      <div className="c-reviews is-visible">
        <div className="c-reviews__inner">
          <div className="c-reviews__title ">{titleText}</div>
          <div className="c-reviews__items review-min-height">
            {map(reviews, review => <Review {...this.props} review={review} />)}
            {fetchingTherapistReviews && <LoadingScreen />}
          </div>
          {!paginate &&
            count > reviewsAtOnce && (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <span className="#" onClick={this.handleShowMore}>
                {showMoreClicked ? 'Show Less' : 'Show More'}
              </span>
            )}
          <div className="w100p flex-center flex-direction-row flex-direction-col-mb relative">
            {paginate && (
              <div className="pagination-status">
                <p>
                  Showing{' '}
                  <span className="fontMrEavesModOT">
                    {offset + 1} -{' '}
                    {offset + reviewsAtOnce <= count
                      ? offset + reviewsAtOnce
                      : count}
                  </span>{' '}
                  of <span className="fontMrEavesModOT">{count}</span>
                </p>
              </div>
            )}
            <div className="pagination-range">
              {paginate && (
                <ReactPaginate
                  previousLabel="<"
                  nextLabel=">"
                  breakLabel={
                    <a aria-label="therapist-review-break-label" href="/#">
                      ...
                    </a>
                  }
                  breakClassName="break-me"
                  pageCount={Math.ceil(count / reviewsAtOnce)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={reviewsAtOnce}
                  onPageChange={this.paginateReviews}
                  containerClassName="form-list pt5"
                  subContainerClassName="pages pagination"
                  activeClassName="active bold"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TherapistReviews.propTypes = {
  titleText: propTypes.string,
  allReviews: propTypes.array,
  therapistReviews: propTypes.array,
  count: propTypes.number,
  sliceReviews: propTypes.array,
  fetchingTherapistReviews: propTypes.func,
  fetchReviews: propTypes.func,
  myTherapistFlow: propTypes.bool,
  paginate: propTypes.bool,
};

export default TherapistReviews;
